module.exports = __webpack_public_path__ + "img/i21.2c8a36fb.svg";